/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_RESCHEDULESLOT, RESCHEDULESLOT_RECEIVED, CLEAR_RESCHEDULESLOT } = constants.AddRescheduleSlot;

export default {
  REQUEST_RESCHEDULESLOT,
  RESCHEDULESLOT_RECEIVED,
  CLEAR_RESCHEDULESLOT,

  requestRescheduleslot: payload => ({
    type: REQUEST_RESCHEDULESLOT,
    payload
  }),
  RescheduleslotReceived: () => ({
    type: RESCHEDULESLOT_RECEIVED
  })
};
